import * as get from 'lodash/get';

import { WebUserDataConstants } from '../constants';
import { ModelPortfolioBuilder } from './../builders/model-portfolio.builder';
import { SecurityDirector } from './../directors/security-director';
import { ModelPortfolio } from './../models/model-portfolio';
import { Security } from './../models/security';

export class ModelPortfolioDirector {
	public construct(portfolioJson: any, builder = new ModelPortfolioBuilder(), securityBuilder = new SecurityDirector()): ModelPortfolio {
		// i dont think this is needed, should be removed from the dashboard component
		const holdings = portfolioJson.holdings;
		let isAssetClassOnly = false;
		if (portfolioJson.children) {
			isAssetClassOnly = !!portfolioJson.children.find(child => child.subType === 'ASSET_CLASS');
		}

		if (portfolioJson.subType === WebUserDataConstants.SUBTYPE.EXTERNAL_PORTFOLIO) {
			portfolioJson = { ...portfolioJson, uniqueId: portfolioJson.id ?? portfolioJson.uniqueId };
		}

		return builder
			.setApplications(['bfa']) // should ask backend to include this
			.setBaseModel(portfolioJson.baseModel)
			.setChildCount(portfolioJson?.childCount)
			.setDescription(
				portfolioJson.modelPortfolio
					? portfolioJson.modelPortfolio.attributesByCodeMap
						? portfolioJson.modelPortfolio.attributesByCodeMap.model_portfolio_long_name
							? portfolioJson.modelPortfolio.attributesByCodeMap.model_portfolio_long_name.attributeTranslation
							: null
						: null
					: portfolioJson.description
						? portfolioJson.description
						: portfolioJson.name
							? portfolioJson.name
							: null
			)
			.setDesignation(portfolioJson.outputDesignation)
			.setFlags({ inputWithValues: false })
			.setOrigin('bfa')
			.setSubType(portfolioJson.subType ? portfolioJson.subType : portfolioJson.portfolioType ? portfolioJson.portfolioType : '')
			.setType(portfolioJson.type ? portfolioJson.type : 'PORTFOLIO')
			.setUniqueId(
				portfolioJson.uniqueId
					? portfolioJson.uniqueId.toString()
					: portfolioJson.portfolioId
						? portfolioJson.portfolioId.toString()
						: portfolioJson.id
							? portfolioJson.id.toString()
							: null
			)
			.setParentId(portfolioJson.parentId ? portfolioJson.parentId.toString() : null)
			.setDateLastModified(portfolioJson.dateLastModified)
			.setNetExpenseRatio(portfolioJson.analyticsMap)
			.setNetExpenseRatioAsOfDate(portfolioJson.asOfDate ? portfolioJson.asOfDate : null)
			.setPortfolioId(portfolioJson.portfolioId)
			.setSecurities(
				holdings && holdings.length
					? holdings.map(holding => {
						return securityBuilder.constructBaseHolding(holding);
					})
					: null
			)
			.setYieldValue(portfolioJson.analyticsMap)
			.setYieldAsOfDate(portfolioJson.asOfDate ? portfolioJson.asOfDate : null)
			.setHoldingAsOfDate(
				portfolioJson.type && portfolioJson.type === 'MODEL_PORTFOLIO'
					? get(portfolioJson, 'modelPortfolio.currentRebalanceDate')
					: portfolioJson.portfolioType && portfolioJson.portfolioType === 'PORTFOLIO'
						? portfolioJson.asOfDate
						: null
			)
			.setStandardDeviation(portfolioJson.riskData && portfolioJson.riskData.totalRisk ? portfolioJson.riskData.totalRisk : null)
			.setIsAssetClassOnly(isAssetClassOnly)
			.setPrevRebalancedDate(portfolioJson.type === 'MODEL_PORTFOLIO' ? get(portfolioJson, 'modelPortfolio.previousRebalanceDate') : null)
			.setTags(portfolioJson.tags ?? [])
			.setACTags(portfolioJson.acTags ?? [])
			.setHoldingsError(portfolioJson.hasHoldingsError)
			.setSubTypeKey(portfolioJson.subTypeKey ?? '')
			.setEncrypted(portfolioJson.encrypted)
			.setOriginPlatform(portfolioJson.originPlatform)
			.build();
	}

	public constructByParams(
		uniqueId: string,
		description: string,
		subType: string,
		baseModel: number,
		dateLastModified: string,
		portfolioId: number,
		holdingAsOfDate: any,
		securities: Array<Security>,
		netExpenseRatio: number,
		netExpenseRatioAsOfDate: number,
		yieldValue: number,
		yieldAsOfDate: number,
		standardDeviation: number,
		standardDeviationAsOfDate: number,
		prevRebalancedDate: string,
		builder = new ModelPortfolioBuilder()
	): ModelPortfolio {
		return builder
			.setApplications(['bfa']) // should ask backend to include this
			.setBaseModel(baseModel)
			.setDescription(description)
			.setFlags({ inputWithValues: false })
			.setOrigin('bfa')
			.setSubType(subType)
			.setType('PORTFOLIO')
			.setUniqueId(uniqueId)
			.setDateLastModified(dateLastModified)
			.setNetExpenseRatioNumber(netExpenseRatio)
			.setNetExpenseRatioAsOfDate(netExpenseRatioAsOfDate)
			.setPortfolioId(portfolioId)
			.setSecurities(securities)
			.setYieldValueNumber(yieldValue)
			.setYieldAsOfDate(yieldAsOfDate)
			.setHoldingAsOfDate(holdingAsOfDate)
			.setStandardDeviation(standardDeviation)
			.setStandardDeviationAsOfDate(standardDeviationAsOfDate)
			.setPrevRebalancedDate(prevRebalancedDate)
			.build();
	}
}
